module.exports = __webpack_public_path__ + "img/price-2-star.a1637ba8.png";